import ApprovalsRequest from './ApprovalRequest';

export default class AppExtensionRequest extends ApprovalsRequest {
	constructor(
		app,
		createdBy,
		approvalFlowType,
		reviewers = null,
		applicationExtensions = null,
		newAppExtension,
		requirementNumber
	) {
		super(
			app,
			createdBy,
			approvalFlowType,
			reviewers,
			applicationExtensions,
			requirementNumber
		);
		this.newAppExtension = newAppExtension;
	}
}
